import { BracketViewer } from "components/Bracket/BracketViewer";
import { BracketMakePicksMatchArgs } from "components/Bracket/BracketMatchArgs";
import { CenterFlexColumn } from "styles/layout";
import { ErrorText } from "styles/text";
import { Pick } from "model/Pickem/Pickem";
import { Panel } from "components/Panel/Panel";
import { Bracket } from "model/Tournament/Segment/Bracket/Bracket";
import { useAppSelector } from "app/hooks";
import { selectBracketPickOptions } from "model/Bracket/BracketPickOptions";

interface Props {
  bracket: Bracket;
  picks: {
    [id: string]: Pick;
  };
  updatePick: (matchId: string, rosterId: string | undefined) => void;
  tournamentId: string;
}

export const BracketemBracketPicker = ({
  bracket,
  picks,
  updatePick,
  tournamentId,
}: Props) => {
  const pickOptions = useAppSelector((state) =>
    selectBracketPickOptions(state, bracket, picks)
  );

  const bracketMatchArgs: BracketMakePicksMatchArgs = {
    picks,
    updatePick,
    pickOptions,
  };

  return (
    <Panel header={bracket.name}>
      <CenterFlexColumn>
        {!bracket.graph ? (
          <ErrorText style={{ paddingTop: "10px" }}>
            Bracket could not be built
          </ErrorText>
        ) : (
          <>
            <div
              style={{
                display: "block",
                maxWidth: "100%",
                overflow: "auto",
                marginTop: "10px",
                paddingBottom: "15px",
              }}
            >
              <BracketViewer
                bracket={bracket}
                bracketMatchArgs={bracketMatchArgs}
                compact={false}
                tournamentId={tournamentId}
              />
            </div>
          </>
        )}
      </CenterFlexColumn>
    </Panel>
  );
};
